<div class="heading-elements">
  <button class="btn btn-sm round btn-outline-info" data-toggle="modal" data-target="#modalRegisterForm">
    Upload IMTO Fund <i class="icons icon-fund-history"></i></button>
    <div class="modal fade" id="modalRegisterForm" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header text-center">
            <h4 class="modal-title w-100 font-weight-bold">Fund IMTO Account</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form [formGroup]="form" (ngSubmit)="addFund()" >
            <div class="modal-body mx-3">
              <div class="md-form mb-1">
                <div class="form-group row">
                  <label for="agent" class="col-sm-4 col-form-label" >Imto Name</label>
                  <div class="col-sm-8">
                    <select class="form-control round" formControlName="agent" name="agent" id="agent">
                      @for (agent of agents; track agent) {
                        <option [value]="agent.id">{{ agent.name }}</option>
                      }
                    </select>

                    @if (agent.touched && agent.invalid) {
                      <div class="alert alert-danger error">
                        @if (agent.errors.required) {
                          <div>Imto Name is required</div>
                        }
                        @if (agent.errors.minlength) {
                          <div>Imto Name should be minimum of 3 characters</div>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div class="md-form mb-1">
                <div class="form-group row">
                  <label for="agent" class="col-sm-4 col-form-label">Foreign Currency</label>
                  <div class="col-sm-8">
                    <select class="form-control round" formControlName="currency_id" name="currency" id="currency" (change)="setCode()">
                      @for (currency of currencies; track currency) {
                        <option [value]="currency.id">{{ currency.code +' '+currency.country }}</option>
                      }
                    </select>

                    @if (currency.touched && currency.invalid) {
                      <div class="alert alert-danger error">
                        @if (currency.errors.required) {
                          <div>Currency is required</div>
                        }
                        @if (currency.errors.minlength) {
                          <div>Currency should be minimum of 3 characters</div>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>

              <div class="md-form mb-1">
                <div class="form-group row">
                  <label for="exchange_rate" class="col-sm-4 col-form-label" >Exchange Rate</label>
                  <div class="col-sm-8">
                    <input type="tel" formControlName="exchange_rate"  name="exchange_rate" (keyup)="generateNaira()" class="form-control round" id="exchange_rate"/>

                    @if (exchange_rate.invalid && exchange_rate.touched) {
                      <div class="alert alert-danger error">
                        @if (exchange_rate.errors.required) {
                          <div>Exchange Rate is required</div>
                        }
                        @if (exchange_rate.errors.minlength) {
                          <div>Please complete the numbers</div>
                        }
                        @if (exchange_rate.errors.pattern) {
                          <div>Please remove special characters</div>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div class="md-form mb-1">
                <div class="form-group row">
                  <label for="amount_in_usd" class="col-sm-4 col-form-label" >Amount in ({{code}})</label>
                  <div class="col-sm-8">
                    <input type="tel" formControlName="amount_in_usd" (keyup)="generateNaira()" name="amount_in_usd" class="form-control round" id="amount_in_usd"/>

                    @if (amount_in_usd.invalid && amount_in_usd.touched) {
                      <div class="alert alert-danger error">
                        @if (amount_in_usd.errors.required) {
                          <div>Amount in {{code}} is required</div>
                        }
                        @if (amount_in_usd.errors.pattern) {
                          <div>Please remove special characters</div>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div class="md-form mb-1">
                <div class="form-group row">
                  <label for="amount_in_naira" class="col-sm-4 col-form-label" >Amount in (NGN)</label>
                  <div class="col-sm-8">
                    <input type="tel" formControlName="amount_in_naira"  name="amount_in_naira" class="form-control round" id="amount_in_naira" [readOnly]="true"/>

                    @if (amount_in_naira.invalid && amount_in_naira.touched) {
                      <div class="alert alert-danger error">
                        @if (amount_in_naira.errors.required) {
                          <div>Amount in NGN is required</div>
                        }
                        @if (amount_in_naira.errors.pattern) {
                          <div>Please remove special characters</div>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>

            </div>
            <div class="modal-footer d-flex justify-content-center">
              <button class="btn btn-success btn-round pl-30 pr-30" [disabled]="form.invalid || clicked === true">Submit </button>@if (clicked === true) {
              <i class="icons icon-loading"></i>
            }
          </div>
        </form>
      </div>
    </div>
  </div>

</div>
